module.exports = __webpack_public_path__ + "static/media/HCMM492.22cf5127.jpg";